"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const _1 = require(".");
const IM_LOGO_MACRO = '{IM_L}';
const getRequiredLogoNamesToBeLoaded = (obj) => {
    if (typeof obj === 'string' && obj.startsWith(IM_LOGO_MACRO)) {
        return [obj.replace(IM_LOGO_MACRO, '')];
    }
    if (typeof obj !== 'object' || !obj) {
        return [];
    }
    return Object.keys(obj).reduce((current, key) => {
        return [...current, ...getRequiredLogoNamesToBeLoaded(obj[key])];
    }, []);
};
const preloadLogos = (chartConfiguration, onSuccess, onError) => {
    const requiredLogos = getRequiredLogoNamesToBeLoaded(chartConfiguration);
    _1.LogoProvider.getLogoByBrandNameAsync(lodash_1.default.compact(requiredLogos) || [], "LOGO30" /* LogoSize.LOGO30 */, (response) => {
        onSuccess(lodash_1.default.keyBy(response, 'brandName'));
    }, onError);
};
const normalizeValue = (value) => {
    return lodash_1.default.isString(value) ? value.replace(IM_LOGO_MACRO, '') : value;
};
const getLogoUrlFor = (rawValue, brandLogos, defaultLogo) => {
    const name = normalizeValue(rawValue);
    return (brandLogos[name] || defaultLogo).logoUrl;
};
const syncLogoCache = (logoSize = "LOGO30" /* LogoSize.LOGO30 */) => {
    _1.LogoProvider.getAvailableLogos(logoSize, () => {
        console.log('Successfully synced brand logos on local cache!');
    });
};
const getLogoByBrandName = (brandName, logoSize = "LOGO30" /* LogoSize.LOGO30 */, defaultLogo) => {
    const foundLogo = _1.LogoProvider.getLogoByBrandFromLocalStorage(brandName, logoSize);
    if (!foundLogo) {
        _1.LogoProvider.populateMissingLogoByBrandName([brandName], logoSize, () => {
            console.log(`Logo not found on local cache (${brandName} - ${logoSize}). Created request to populate`);
        });
        return defaultLogo;
    }
    return foundLogo;
};
const LogoIntegrationService = {
    IM_LOGO_MACRO,
    preloadLogos,
    syncLogoCache,
    normalizeValue,
    getLogoUrlFor,
    getLogoByBrandName,
};
exports.default = LogoIntegrationService;
